export default "__VITE_ASSET__Do2kyoeC__"